import React, { Component } from 'react';

export function NotFound(){
    return <h1>NOT FOUND</h1>
}